import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as surveyConfiguration from '../../../survey-configuration'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Reloads the current records list whenever survey configuration is
 * successfully updated.
 */
export const reloadOnSurveyConfigurationChange = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: Collection,
    surveyConfigurationFeature: surveyConfiguration.Feature,
  ) =>
    surveyConfigurationFeature.actions.upsert.success
      .observe()
      .pipe(
        rxjs.map(() =>
          collection.plugins.currentListPlugin.feature.actions.load
            .from('(effect) reload on survey configuration change')
            .create(),
        ),
      ),
)
